import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuthenticatedQueryFn } from '@/hooks/useAuthenticatedQuery';
import { duplicateAsset } from '@/services/asset.service';
import { useToast } from '@/components/ui/use-toast';
import { error as errorLog } from '@/utilities/log';
import { QueryKey } from '@/lib/queryKeys';
import { useTranslations } from 'next-intl';

export const useDuplicateAsset = () => {
  const tToasts = useTranslations('toasts');

  const { toast } = useToast();
  const queryClient = useQueryClient();
  const duplicateAssetWithAuth = useAuthenticatedQueryFn(duplicateAsset);

  const duplicateAssetMutation = useMutation({
    mutationFn: duplicateAssetWithAuth,
    onSuccess: () => {
      toast({
        title: tToasts('duplicateAssetMutation.title'),
        description: tToasts('duplicateAssetMutation.description'),
      });

      void queryClient.invalidateQueries({ queryKey: [QueryKey.Asset] });
      void queryClient.invalidateQueries({ queryKey: [QueryKey.AssetData] });
    },
    onError: (err) => {
      errorLog(err);
    },
  });

  return { duplicateAssetMutation };
};
